import { Skeleton } from 'antd';
import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants/styles';
import { BlueColors, NeutralColors } from '@/theme';

export const Trigger = styled.button<{ $hasIcon: boolean; $isOpen: boolean }>`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 48px;
  max-width: 300px;
  padding: 4px;
  padding-right: 16px;
  border: 2px solid
    ${({ $isOpen }) => ($isOpen ? BlueColors[30] : NeutralColors[10])};
  border-radius: 40px;
  background: ${({ $isOpen }) => ($isOpen ? BlueColors[10] : NeutralColors[0])};
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    border-color: ${({ $isOpen }) =>
      $isOpen ? BlueColors[30] : BlueColors[50]};
  }

  .${CSS_PREFIX}-typography {
    display: block;
  }

  > .anticon {
    flex-shrink: 0;
    color: ${NeutralColors[40]};
    font-size: 10px;
  }

  svg {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.3s;
  }
`;

export const TriggerIcon = styled.span<{ $isOpen: boolean }>`
  display: flex;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${({ $isOpen }) => ($isOpen ? BlueColors[20] : NeutralColors[10])};
  color: ${BlueColors[60]};
  transition: background 0.3s;

  svg {
    transform: none;
  }
`;

export const TriggerLabel = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  padding: 0 12px;

  .${CSS_PREFIX}-typography:first-child {
    color: ${NeutralColors[60]};
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
  }

  .${CSS_PREFIX}-typography:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${NeutralColors[100]};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }
`;

export const LoadingLabel = styled(Skeleton.Input).attrs({ size: 'small' })`
  margin-top: 2px;
`;

export const Panel = styled.div<{ $width: number }>`
  display: flex;
  width: ${({ $width }) => `${$width}px`};
  max-width: calc(100vw - 48px);
  flex-direction: column;
  gap: 12px;
`;
